/**
 * leadingSideInner.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";
//import moment from "moment-timezone";

interface Props {
  children: React.ReactNode | Array<React.ReactNode>;
}

export function LeadingSideInner(props: Props): React.ReactElement<any, any> {
  //const now = moment();
  return <div className="leading-side-inner leading-side-container">
    {props.children}
  </div>;
  /*<div className="leading-side-footer">
      <div className="powered-by-secured">Powered by Secured Communications</div>
      <div>&copy; Secured Communications, {now.format("yyyy")}</div>
    </div>*/
}
